module.exports = __webpack_public_path__ + "img/svg/recover-account-background-mobile.b1f8e88f781448b7ba59057f750641ff.svg";